module.exports = __webpack_public_path__ + "static/media/neural.5aa6bdcc.gif";